import { css } from "styled-components";
import { reset } from "./reset";
import { collapse } from "./motion/collapse";
import { fade } from "./motion/fade";
import { slide } from "./motion/slide";
import { wave } from "./motion/wave";
import { zoom } from "./motion/zoom";
import { button } from "./components/button";
import { checkbox } from "./components/checkbox";
import { datePicker } from "./components/date-picker";
import { drawer } from "./components/drawer";
import { dropdown } from "./components/dropdown";
import { empty } from "./components/empty";
import { input } from "./components/input";
import { inputNumber } from "./components/input-number";
import { menu } from "./components/menu";
import { modal } from "./components/modal";
import { pagination } from "./components/pagination";
import { popover } from "./components/popover";
import { radio } from "./components/radio";
import { select } from "./components/select";
import { spinner } from "./components/spinner";
import { tabs } from "./components/tabs";
import { tooltip } from "./components/tooltip";
import { tree } from "./components/tree";
import { upload } from "./components/upload";
export const globalStyle = css(["", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], reset, collapse, fade, slide, wave, zoom, button, checkbox, datePicker, drawer, dropdown, empty, input, inputNumber, menu, modal, pagination, popover, radio, select, spinner, tabs, tooltip, tree, upload);